// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  recId: __t.u64().primaryKey().name("rec_id"),
  worldId: __t.u64().name("world_id"),
  settlementId: __t.u64().name("settlement_id"),
  mayorId: __t.u64().name("mayor_id"),
  termStartAt: __t.timestamp().name("term_start_at"),
  treasuryStart: __t.i64().name("treasury_start"),
  lawsPassed: __t.u32().name("laws_passed"),
  warsWon: __t.u32().name("wars_won"),
  warsLost: __t.u32().name("wars_lost"),
  famineEpochs: __t.u32().name("famine_epochs"),
  updatedAt: __t.timestamp().name("updated_at"),
});
